import React, { FC } from 'react';
import { IMAGE_SIZE } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { ResultContainer } from './style';
import { GlobalIcon } from 'components/GlobalIcon';
import { ResultSubTitle, ResultTitle } from '../style';

type Props = {
  title: string;
  gameText: string;
  size?: number;
  isSportsTournament?: boolean;
};

export const EmptyCasinoGames: FC<Props> = ({
  title,
  gameText,
  size = IMAGE_SIZE._176,
  isSportsTournament
}) => {
  return (
    <ResultContainer
      style={isSportsTournament && !isMobile() ? { height: 450 } : {}}
      title={<ResultTitle>{title}</ResultTitle>}
      icon={
        <GlobalIcon
          lib="casino"
          name="noCasinoGames"
          theme="colored"
          size={size}
          skeleton={{ useEmptyPlaceholder: true }}
        />
      }
      subTitle={<ResultSubTitle>{gameText}</ResultSubTitle>}
    />
  );
};
